export default __webpack_public_path__ + "static/media/Care03.92cd4df5.png";